import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import viewDeploymentOrganizations from './viewRelatedDeploymentOrganizations';

export default {
  attributeName: 'liveSettings',
  canOpen: true,
  canEdit: true,
  canCreate: false,
  createPath: routes.LIVE_SETTINGS_NEW,
  editURL: routes.LIVE_SETTINGS_EDIT,
  canRemove: true,
  
  emptyMessage: "You don't have live settings items, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The name of the set of settings. It must be without spaces and special characters. It must be unique per app.',
      default: '',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
    },
    {
      attributeName: 'isDefault',
      label: 'Is Default?',
      type: FormInputTypes.CHECKBOX,
      canEdit: true,
      canOrder: false,
      canCreate: false,
      disabled:true,
      helpText: 'checked if this setting is by default.',
      width: '8rem',
      default: false,
    },
   
  ],
};


